<template>
	<div>
        <input type="file" @change="onFileChanged">
        <v-btn @click="onUpload">Upload</v-btn>
        <h3 v-if="uploadFinished" id="green">Uploaded successfully</h3>
    </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import Firebase from "firebase";
import SignUp from "./SignUp";

export default {
    data(){
        return {
            uploadFinished: false
        }
    },

    components: {
        SignUp
    },

	methods: {
        // File selection
        onFileChanged(event) {
            this.selectedFile = event.target.files[0];
        },

        // Handle upload procedure
        onUpload() {
			const storageRef = Firebase.storage().ref();
            var file = this.selectedFile;
            var metadata = {
                contentType: 'image/jpeg'
            };

            // var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);
            var uploadTask = storageRef.child("myfiles/" + this.uuid + "/" + file.name).put(file, metadata);
            console.log('upload task', uploadTask);
            let that = this;
            let that2 = SignUp;

            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(Firebase.storage.TaskEvent.STATE_CHANGED,
                function (snapshot) {
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case Firebase.storage.TaskState.PAUSED:
                            console.log('Upload is paused');
                            break;
                        case Firebase.storage.TaskState.RUNNING:
                            console.log('Upload is running');
                            break;
                    }
                },
                function (error) {
                    switch (error.code) {
                        case 'storage/unauthorized':
                            break;
                        case 'storage/canceled':
                            break;
                        case 'storage/unknown':
                            break;
                    }
                },
                async function () {
                    // Upload completed successfully, now we can get the download URL
                    var url = await uploadTask.snapshot.ref.getDownloadURL();
                    console.log('url: ', url);
                    Vue.set(that2, 'profileImageUrl', url);
                    Vue.set(that, 'uploadFinished', true);
                }
            );
        }
	}
}
</script>
